import React from 'react';
import * as fromComponents from 'components'

export const ContextMenu = ({ children }) => {


    return <fromComponents.ContextMenuPortal>{ children }</fromComponents.ContextMenuPortal>
}

